<script>
  import { navigate } from "svelte-routing";

  const timers = () => {
    navigate("/timers");
  };

  let beep = new Audio("/sons/beep03.mp3");
  let beep2 = new Audio("/sons/beep04.mp3");
  let beep3 = new Audio("/sons/beep02.mp3");
  let rounds = 10;
  let minutes = 1;
  let seconds = 0;
  let currentRound = 0;
  let timeLeft = minutes * 60 + seconds;
  let isActive = false;
  let interval;
  let showModal = false;
  let countdown = 4;

  function formatTime(totalSeconds) {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  function startTimer() {
    showModal = true;
    countdown = 4;
    beep.play();

    const countdownInterval = setInterval(() => {
      if (countdown > 2) {
        beep.play();
      } else if (countdown === 2) {
        beep2.play();
      }

      countdown--;
      if (countdown === 0) {
        clearInterval(countdownInterval);
        showModal = false;
        isActive = true;
        currentRound = 1;
        timeLeft = minutes * 60 + seconds;
        interval = setInterval(() => {
          timeLeft--;

          if (timeLeft <= 3 && timeLeft > 0) {
            beep.play();
          }

          if (timeLeft <= 0) {
            beep3.play();

            currentRound++;
            if (currentRound > rounds) {
              clearInterval(interval);
              isActive = false;
              return;
            }
            timeLeft = minutes * 60 + seconds;
          }
        }, 1000);
      }
    }, 1000);
  }

  function stopTimer() {
    clearInterval(interval);
    isActive = false;
    timeLeft = minutes * 60 + seconds;
    currentRound = 0;
  }

  function resetTimer() {
    stopTimer();
    rounds = 10;
    minutes = 1;
    seconds = 0;
  }
</script>

<div class="margem">
  <div>
    <label on:click={timers}><strong>Voltar</strong></label>
  </div>

  <div class="fonte2">
    <strong>EMOM</strong>
  </div>

  {#if !isActive}
    <div class="bordaGeral">
      Rounds
      <div class="buttons-container fonte">
        <div class="label">{rounds}</div>
        <button on:click={() => (rounds = Math.max(1, rounds - 1))}>-</button>
        <button on:click={() => rounds++}>+</button>
      </div>
      <hr />

      Minuto(s)
      <div class="buttons-container fonte">
        <div class="label">{minutes}</div>
        <button on:click={() => (minutes = Math.max(0, minutes - 1))}>-</button>
        <button on:click={() => minutes++}>+</button>
      </div>
      <hr />

      Segundo(s)
      <div class="buttons-container fonte">
        <div class="label">{seconds}</div>
        <button on:click={() => (seconds = Math.max(1, seconds - 1))}>-</button>
        <button on:click={() => seconds++}>+</button>
      </div>
    </div>
  {:else}
    <div class="bordaGeral">
      <div class="fonteTempoRound">
        {formatTime(timeLeft)}
      </div>

      Rounds
      <div class="round">
        {currentRound}/{rounds}
      </div>
    </div>
  {/if}
  <br />

  <div class="buttons">
    {#if isActive}
      <button on:click={stopTimer}>PARAR</button>
    {:else}
      <button on:click={startTimer}>INICIAR</button>
      <button on:click={resetTimer}>Ressetar</button>
    {/if}
  </div>

  {#if showModal}
    <div class="modal">
      <div class="modal-content">
        {#if countdown > 1}
          {countdown - 1}
        {:else}
          Go!
        {/if}
      </div>
    </div>
  {/if}
</div>

<style>
  .label {
    width: 100px;
    text-align: center;
    border: 2px solid darkblue;
    background: #ffffff;
    padding: 0px;
    font-size: 1em;
    border-radius: 5px;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-content {
    background-color: rgb(15, 0, 42);
    padding: 20px;
    border-radius: 5px;
    text-align: center;
    font-size: 5em;
    color: #d3f3ff;
  }

  .bordaGeral {
    border: 2px solid #dedede;
    border-radius: 5px;
    background: #cbd4fd;
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center; /* Centraliza itens horizontalmente */
  }

  .fonte {
    font-size: 30px;
    font-weight: bold;
    color: #000080;
  }

  .fonte2 {
    font-size: 30px;
    font-weight: bold;
    color: #000080;
    text-align: center;
  }
  .fonteTempoRound {
    font-size: 90px;
    font-weight: bold;
    color: #000080;
  }

  .round {
    font-size: 60px;
    font-weight: bold;
    color: #015156;
  }

  .fonteDescanso {
    font-size: 35px;
    font-weight: bold;
    color: #ff0000;
  }

  .fonteAtividade {
    font-size: 35px;
    font-weight: bold;
    color: #00a933;
  }

  .buttons-container {
    display: flex;
    gap: 10px; /* Espaçamento entre os botões */
    margin-top: 10px; /* Espaçamento entre o label e os botões */
  }
  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 20px;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1.3rem;
    padding: 0.3rem 1rem;
    border: none;
    border-radius: 4px;
    background-color: #1976d2;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }
</style>
